import React, { useMemo, useState } from "react";

export default function ManualEmailSender({
  endpoint = "/api/admin/email/send-manual",
  senderProfiles = [],
  defaultSenderProfileId = "",
}) {
  const [toEmail, setToEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [subject, setSubject] = useState("");
  const [bodyHtml, setBodyHtml] = useState("");
  const [senderProfileId, setSenderProfileId] = useState(defaultSenderProfileId);

  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const parsedEmails = useMemo(() => {
    return toEmail
      .split(/[\n,;]+/)
      .map((x) => x.trim().toLowerCase())
      .filter(Boolean);
  }, [toEmail]);

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invalid = parsedEmails.find((x) => !isValidEmail(x));
    if (!parsedEmails.length || invalid) {
      setError("Укажите корректный email получателя (можно несколько)");
      return;
    }

    if (!subject.trim()) {
      setError("Укажите тему письма");
      return;
    }

    if (!bodyHtml.trim()) {
      setError("Текст письма не может быть пустым");
      return;
    }

    setPending(true);
    setError("");
    setResult(null);

    const payload = {
      emails: parsedEmails,
      subject: subject.trim(),
      body_html: bodyHtml,
    };

    // Поля передаем опционально для будущего учета связки с клиентом и профиля отправителя.
    if (userId.trim()) {
      payload.user_id = Number(userId);
    }
    if (senderProfileId !== "") {
      payload.sender_profile_id = Number(senderProfileId);
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setError(data.error || "Ошибка отправки письма");
        return;
      }

      setResult(data);
      setToEmail("");
      setUserId("");
      setSubject("");
      setBodyHtml("");
    } catch (submitError) {
      setError("Сетевая ошибка");
    } finally {
      setPending(false);
    }
  };

  return (
    <section style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 12, marginTop: 12 }}>
      <h3 style={{ marginTop: 0 }}>Ручная отправка Email</h3>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 8 }}>
          <label htmlFor="manual-email-to">Кому</label>
          <input
            id="manual-email-to"
            type="text"
            value={toEmail}
            onChange={(e) => setToEmail(e.target.value)}
            placeholder="client1@example.com, client2@example.com"
            style={{ width: "100%", boxSizing: "border-box", padding: 8, marginTop: 4 }}
          />
          <small style={{ color: "#555" }}>Можно указать несколько адресов через запятую, ; или новую строку.</small>
        </div>

        <div style={{ marginBottom: 8 }}>
          <label htmlFor="manual-email-user-id">User ID (необязательно)</label>
          <input
            id="manual-email-user-id"
            type="number"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="например 123"
            style={{ width: "100%", boxSizing: "border-box", padding: 8, marginTop: 4 }}
          />
        </div>

        <div style={{ marginBottom: 8 }}>
          <label htmlFor="manual-email-sender">Профиль отправителя</label>
          <select
            id="manual-email-sender"
            value={senderProfileId}
            onChange={(e) => setSenderProfileId(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: 8, marginTop: 4 }}
          >
            <option value="">По умолчанию</option>
            {senderProfiles.map((profile) => (
              <option key={profile.id} value={profile.id}>
                {profile.display_name || profile.from_name || profile.email_from}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: 8 }}>
          <label htmlFor="manual-email-subject">Тема</label>
          <input
            id="manual-email-subject"
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: 8, marginTop: 4 }}
          />
        </div>

        <div style={{ marginBottom: 8 }}>
          <label htmlFor="manual-email-body">Текст письма (HTML)</label>
          <textarea
            id="manual-email-body"
            rows={10}
            value={bodyHtml}
            onChange={(e) => setBodyHtml(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", padding: 8, marginTop: 4 }}
          />
        </div>

        {error && <p style={{ color: "#b91c1c", margin: "8px 0" }}>{error}</p>}

        {result && (
          <p style={{ color: "#166534", margin: "8px 0" }}>
            Отправлено: {result.sent ?? 0}
            {Array.isArray(result.errors) && result.errors.length > 0
              ? `, ошибок: ${result.errors.length}`
              : ""}
          </p>
        )}

        <button type="submit" disabled={pending}>
          {pending ? "Отправляем..." : "Отправить письмо"}
        </button>
      </form>
    </section>
  );
}
